<template>
  <div>
    <load-profile />
    <b-tabs
      v-model="activeTabIndex"
      vertical
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-3 col-12"
      nav-class="nav-left"
    >
      <!-- Config tab -->
      <b-tab lazy>
        <template #title>
          <feather-icon icon="SettingsIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{ $t('breadcrumb.config') }}</span>
        </template>
        <config-content ref="configContent" @refresh="getAssignment" />
      </b-tab>

      <!-- Service Category tab -->
      <b-tab lazy>
        <template #title>
          <feather-icon icon="GridIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{ $t('breadcrumb.serviceCategory') }}</span>
        </template>
        <service-category />
      </b-tab>

      <!-- Service Type tab -->
      <b-tab lazy>
        <template #title>
          <feather-icon icon="LayersIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{ $t('breadcrumb.serviceType') }}</span>
        </template>
        <service-type />
      </b-tab>

      <!-- Service Sub Type tab -->
      <b-tab lazy>
        <template #title>
          <feather-icon icon="TrelloIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{ $t('breadcrumb.serviceSubType') }}</span>
        </template>
        <service-sub-type />
      </b-tab>

      <!-- Service Product tab -->
      <b-tab lazy>
        <template #title>
          <feather-icon icon="ShoppingBagIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{ $t('breadcrumb.serviceProduct') }}</span>
        </template>
        <service-product />
      </b-tab>

      <b-tab lazy>
        <template #title>
          <feather-icon icon="SpeakerIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{ $t('breadcrumb.voiceAlertSettings') }}</span>
        </template>
        <speech-alert />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BTab, BTabs } from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import ConfigContent from './components/ConfigContent.vue'
import ServiceCategory from './components/ServiceCategory.vue'
import ServiceType from './components/ServiceType.vue'
import SpeechAlert from './SpeechAlert.vue'
import ServiceSubType from './components/ServiceSubType.vue'
import ServiceProduct from './components/ServiceProduct.vue'


const ChatAssignmentRepository = Repository.get('chatAssignmentRepository')

export default {
  components: {
    BTab,
    BTabs,
    ConfigContent,
    ServiceCategory,
    ServiceType,
    SpeechAlert,
    ServiceSubType,
    ServiceProduct,
  },
  data() {
    return {
      activeTabIndex: 0,
    }
  },
  methods: {
    async getAssignment() {
      try {
        const response = await ChatAssignmentRepository.show()
        const { data } = response.data
        if (data.serviceSystemConfig && this.$refs.configContent) {
          this.$refs.configContent.updateData(data.serviceSystemConfig)
        }
      } catch (err) {
        const { data } = err.response
        const { message } = data
        if (message === 'error.recordNotFound') await this.createAssignment()
      }
    },
    async createAssignment() {
      try {
        await ChatAssignmentRepository.show()
        await this.getAssignment()
      } catch (err) {
        console.error(err)
      }
    },
  },
  mounted() {
    this.getAssignment()
  },
  setup() {
    const permissionType = 'merchant-integration'
    return { permissionType }
  },
}
</script>

<style>
.form-tags.form-control {
  height: calc(2.714rem - 0.44rem * 2);
}
.form-tags.form-control:focus {
  box-shadow: none !important;
}
</style>
